import { useState } from "react";
import { cn } from "@/lib/cn";
import { Floating, Icon } from "@/shared";
import { useFilter } from "../../providers";

const OPTIONS: {
  key: "all" | "opened" | "resolved";
  label: string;
}[] = [
  {
    key: "all",
    label: "All comments",
  },
  {
    key: "opened",
    label: "Opened",
  },
  {
    key: "resolved",
    label: "Resolved",
  },
];
export const Filter = ({ iconStyle }: { iconStyle: string }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { filter, setFilter } = useFilter();

  return (
    <Floating
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      trigger={
        <div
          className={cn(iconStyle, {
            "tw-border-blue-300 tw-bg-blue-200": isOpen,
          })}
        >
          <Icon icon="ri-filter-3-fill" color="#88819F" />
        </div>
      }
    >
      <div className="tw-flex tw-w-[149px] tw-flex-col tw-gap-1 tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-p-2 tw-shadow-settings-floating">
        {OPTIONS.map((option) => (
          <button
            onClick={() => setFilter(option.key)}
            key={option.key}
            className={cn(
              "tw-flex tw-h-9 tw-w-full tw-items-center tw-rounded tw-px-3 tw-font-sans tw-text-[11px]/tight tw-text-blue-base tw-outline-none tw-transition-colors tw-duration-150 hover:tw-bg-blue-100",
              {
                "tw-bg-blue-100": filter === option.key,
              },
            )}
          >
            <Icon
              icon="ri-check-fill"
              color="#594F78"
              className={cn("tw-mr-2", {
                "tw-invisible tw-opacity-0": filter !== option.key,
              })}
            />
            {option.label}
          </button>
        ))}
      </div>
    </Floating>
  );
};
